// 报表
import report from '@/views/report/report'
import adReport from '@/views/report/adReport'
import baseReport from '@/views/report/baseReport'
import achievement from '@/views/report/achievement'
import statistics from '@/views/report/statistics'
import reporttool from '@/views/report/reporttool'
import customReport from '@/views/report/customReport'
import addCustomReport from '@/views/report/customReport/addCustomReport'
import subscribeReport from '@/views/report/subscribeReport'
import accountAnalysis from '@/views/analyze/accountAnalysis'
import materialAnalysis from '@/views/analyze/materialAnalysis'
import videoAnalysis from '@/views/analyze/videoAnalysis'
import ecReport from '@/views/report/ecReport/ecReport'
import ecPlanReport from '@/views/report/ecReport/ecPlanReport'
import taobaoOrders from '@/views/report/ecReport/taobaoOrders'
import JDOrders from '@/views/report/ecReport/JDOrders'
export default {
  path: '/report',
  name: 'report',
  component: report,
  meta: {
    keepAlive: true,
    title: '报表',
    code: 'page:report',
    activeName: '/report',
    permission: 'report',
    name: 'report'
  },
  children: [
    {
      path: 'baseReport',
      name: 'baseReport',
      component: baseReport,
      meta: {
        keepAlive: true,
        title: '基础报表',
        iconName: 'icon-menuAd',
        permission: 'infrastructure',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'accountReport',
          title: '广告账户'
        },
        {
          name: 'groupReport',
          title: '广告组'
        },
        {
          name: 'planReport',
          title: '广告计划'
        },
        {
          name: 'materialReport',
          title: '素材报表'
        }
      ],
      children: [
        {
          path: 'accountReport',
          name: 'accountReport',
          component: adReport,
          meta: {
            parents: 'baseReport',
            keepAlive: true,
            title: '广告账户',
            permission: 'adReport'
          }
        },
        {
          path: 'groupReport',
          name: 'groupReport',
          component: adReport,
          meta: {
            parents: 'baseReport',
            keepAlive: true,
            title: '广告组',
            permission: 'adReport'
          }
        },
        {
          path: 'planReport',
          name: 'planReport',
          component: adReport,
          meta: {
            parents: 'baseReport',
            keepAlive: true,
            title: '广告计划',
            permission: 'adReport'
          }
        },
        {
          path: 'materialReport',
          name: 'materialReport',
          component: resolve => require(['@/views/report/materialReport'], resolve),
          meta: {
            parents: 'baseReport',
            keepAlive: true,
            title: '素材报表',
            iconName: 'icon-sucaibaobiao',
            permission: 'imgReport'
          }
        }
        // {
        //   path: 'adReport',
        //   name: 'adReport',
        //   component: adReport,
        //   meta: {
        //     parents: 'baseReport',
        //     keepAlive: true,
        //     title: '广告报表',
        //     iconName: 'icon-menuAd',
        //     permission: 'adReport'
        //   }
        // }
      ]
    },
    {
      path: 'ecReport',
      name: 'ecReport',
      component: ecReport,
      meta: {
        keepAlive: true,
        title: '电商报表',
        iconName: 'icon-electricity',
        permission: 'dsReport',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'ecPlanReport',
          title: '计划报表'
        },
        {
          name: 'taobaoOrders',
          title: '淘宝订单'
        },
        {
          name: 'taobaoDdnOrders',
          title: '点点诺淘宝订单'
        },
        {
          name: 'JDOrders',
          title: '京东订单'
        }
      ],
      children: [
        {
          path: 'ecPlanReport',
          name: 'ecPlanReport',
          component: ecPlanReport,
          meta: {
            parents: 'ecPlanReport',
            keepAlive: true,
            title: '计划报表',
            permission: 'dsReport:ad'
          }
        },
        {
          path: 'taobaoOrders',
          name: 'taobaoOrders',
          component: taobaoOrders,
          meta: {
            parents: 'taobaoOrders',
            keepAlive: true,
            title: '淘宝订单',
            permission: ''
          }
        },
        {
          path: 'taobaoDdnOrders',
          name: 'taobaoDdnOrders',
          component: resolve => require(['@/views/report/ecReport/taobaoDdnOrders'], resolve),
          meta: {
            parents: 'taobaoDdnOrders',
            keepAlive: true,
            title: '点点诺淘宝订单',
            permission: ''
          }
        },
        {
          path: 'JDOrders',
          name: 'JDOrders',
          component: JDOrders,
          meta: {
            parents: 'JDOrders',
            keepAlive: true,
            title: '京东订单',
            permission: ''
          }
        }
      ]
    },
    {
      path: 'achievement',
      name: 'achievement',
      component: achievement,
      meta: {
        keepAlive: true,
        title: '业绩报表',
        iconName: 'icon-performanceAnalysis',
        permission: 'performance',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'accountAnalysis',
          title: '账户分析'
        },
        {
          name: 'targetAnalysis',
          title: '目标分析'
        },
        {
          name: 'performanceAnalysis',
          title: '业绩分析'
        },
        {
          name: 'workReport',
          title: '人效分析'
        }
      ],
      children: [
        {
          path: 'accountAnalysis',
          name: 'accountAnalysis',
          component: accountAnalysis,
          meta: {
            parents: 'achievement',
            keepAlive: true,
            title: '账户分析',
            iconName: 'icon-accountAnalysis',
            permission: 'accountAnalysis'
          },
          children: [
            {
              path: 'accountDetails',
              name: 'accountDetails',
              component: resolve => require(['@/views/analyze/accountAnalysis/accountDetails'], resolve),
              meta: {
                keepAlive: true
              }
            }
          ]
        },
        {
          path: 'targetAnalysis',
          name: 'targetAnalysis',
          component: resolve => require(['@/views/analyze/targetAnalysis'], resolve),
          meta: {
            parents: 'achievement',
            keepAlive: true,
            title: '目标分析',
            iconName: 'icon-targetAnalysis',
            permission: 'targetAnalysis'
          },
          children: [
            {
              path: 'details',
              name: 'targetAnalysisDetails',
              component: resolve => require(['@/views/analyze/targetAnalysis/targetAnalysisDetails'], resolve),
              meta: {
                keepAlive: true,
                title: '目标详情'
              }
            }
          ]
        },
        {
          path: 'performanceAnalysis',
          name: 'performanceAnalysis',
          component: resolve => require(['@/views/analyze/performanceAnalysis'], resolve),
          meta: {
            parents: 'achievement',
            keepAlive: true,
            title: '业绩分析',
            iconName: 'icon-performanceAnalysis',
            permission: 'achievementAnalysis'
          }
        },
        {
          path: 'workReport',
          name: 'workReport',
          component: resolve => require(['@/views/report/workReport'], resolve),
          meta: {
            parents: 'achievement',
            keepAlive: true,
            title: '人效分析',
            iconName: 'icon-renxiaobaobiao',
            permission: 'manpower'
          }
        }
      ]
    },
    {
      path: 'statistics',
      name: 'statistics',
      component: statistics,
      meta: {
        keepAlive: true,
        title: '素材统计',
        iconName: 'icon-materialAnalysis',
        permission: 'image:statistics',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'materialAnalysis',
          title: '巨量素材分析'
        },
        {
          name: 'videoAnalysis',
          title: '巨量视频分析'
        }
      ],
      children: [
        {
          path: 'materialAnalysis',
          name: 'materialAnalysis',
          component: materialAnalysis,
          meta: {
            parents: 'statistics',
            keepAlive: true,
            title: '巨量素材分析',
            iconName: 'icon-materialAnalysis',
            permission: 'analyse:image'
          },
          children: [
            {
              path: 'accountMaterialAnalysis',
              name: 'accountMaterialAnalysis',
              component: resolve => require(['@/views/analyze/materialAnalysis/accountMaterialAnalysis'], resolve),
              meta: {
                keepAlive: true
              }
            },
            {
              path: 'creativeDetails',
              name: 'creativeDetails',
              component: resolve => require(['@/views/analyze/materialAnalysis/creativeDetails'], resolve),
              meta: {
                keepAlive: true
              }
            }
          ]
        },
        {
          path: 'videoAnalysis',
          name: 'videoAnalysis',
          component: videoAnalysis,
          meta: {
            parents: 'statistics',
            keepAlive: true,
            title: '巨量视频分析',
            iconName: 'icon-videoAnalysis',
            permission: 'analyse:jl:video'
          },
          children: [
            {
              path: 'accountDetails',
              name: 'videoAccountDetails',
              component: resolve => require(['@/views/analyze/videoAnalysis/videoAccountDetails'], resolve),
              meta: {
                keepAlive: true,
                title: '账户详情'
              }
            },
            {
              path: 'creativeDetails',
              name: 'videoCreativeDetails',
              component: resolve => require(['@/views/analyze/videoAnalysis/videoCreativeDetails'], resolve),
              meta: {
                keepAlive: true,
                title: '创意详情'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'reporttool',
      name: 'reporttool',
      component: reporttool,
      meta: {
        keepAlive: true,
        title: '报表工具',
        iconName: 'icon-menuDz',
        permission: 'statement:tools',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'customReport',
          title: '定制报表'
        },
        {
          name: 'subscribeReport',
          title: '订阅报表'
        }
      ],
      children: [
        {
          path: 'customReport',
          name: 'customReport',
          component: customReport,
          meta: {
            parents: 'reporttool',
            keepAlive: true,
            title: '定制报表',
            iconName: 'icon-menuDz',
            permission: 'customReport'
          },
          children: [
            {
              path: 'addCustomReport',
              name: 'addCustomReport',
              component: addCustomReport,
              meta: {
                keepAlive: true,
                title: '新建报表模板'
              }
            },
            {
              path: 'editCustomReport',
              name: 'editCustomReport',
              component: resolve => require(['@/views/report/customReport/editCustomReport'], resolve),
              meta: {
                keepAlive: true,
                title: '编辑报表模板'
              }
            },
            {
              path: 'customReportDetails',
              name: 'customReportDetails',
              component: resolve => require(['@/views/report/customReport/customReportDetails'], resolve),
              meta: {
                keepAlive: true,
                title: '定制报表详情'
              }
            }
          ]
        },
        {
          path: 'subscribeReport',
          name: 'subscribeReport',
          component: subscribeReport,
          meta: {
            parents: 'reporttool',
            keepAlive: true,
            title: '订阅报表',
            iconName: 'icon-menuDy',
            permission: 'subscribeReport'
          },
          children: [
            {
              path: 'addSubscribeReport',
              name: 'addSubscribeReport',
              component: resolve => require(['@/views/report/subscribeReport/addSubscribeReport'], resolve),
              meta: {
                keepAlive: true,
                title: '新建订阅报表'
              }
            },
            {
              path: 'editSubscribeReport',
              name: 'editSubscribeReport',
              component: resolve => require(['@/views/report/subscribeReport/editSubscribeReport'], resolve),
              meta: {
                keepAlive: true,
                title: '编辑订阅报表'
              }
            },
            {
              path: 'subscribeReportDetails',
              name: 'subscribeReportDetails',
              component: resolve => require(['@/views/report/subscribeReport/subscribeReportDetails'], resolve),
              meta: {
                keepAlive: true,
                title: '订阅报表详情'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'clueReport',
      name: 'clueReport',
      component: resolve => require(['@/views/report/clueReport'], resolve),
      meta: {
        keepAlive: true,
        title: '线索报表',
        iconName: 'icon-renxiaobaobiao',
        permission: 'clueReport',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'ycClue',
          title: '易车'
        }
      ],
      children: [
        {
          path: 'ycClue',
          name: 'ycClue',
          component: resolve => require(['@/views/report/clueReport/ycClue'], resolve),
          meta: {
            parents: 'clueReport',
            keepAlive: true,
            title: '易车',
            permission: 'clueReport:distribute:list'
          }
        }
      ]
    }
    // {
    //   path: 'fishReport',
    //   name: 'fishReport',
    //   component: resolve => require(['@/views/report/fishReport'], resolve),
    //   meta: {
    //     keepAlive: true,
    //     title: '飞鱼线索',
    //     iconName: 'icon-xiansuo-daoyinxuanzhong',
    //     permission: 'feiyuClueReport'
    //   }
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/report.js